import { SET_UTM_CONTENT_SOURCE_TYPE } from 'actions';

export const setUtmContentSourceType = (utmContent: string) => {
  return { type: SET_UTM_CONTENT_SOURCE_TYPE, utmContent };
};
